
window.initPresteemStoryV13=()=>{
 const root=document.getElementById('presteem-story-v13');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';const q=s=>root.querySelector(s);
 const header=document.querySelector('.site-header');if(header)root.style.setProperty('--story-header',Math.round(header.getBoundingClientRect().height)+'px');
 const scroll=q('.pm-scroll'),track=q('.pm-track'),cold=q('.pm-cold'),warm=q('.pm-warm'),shade=q('.pm-shadow'),product=q('.pm-product'),before=q('.pm-before'),after=q('.pm-after'),end=q('.pm-end');
 const sequence=root.closest('.presteem-story-sequence'),hero=sequence.querySelector('#top'),heroCopy=hero.querySelector('.hero-content'),stage=q('.pm-stage');
 let entryOpacity=0,entryDistance=0,entranceShown=0;
 function sizeSequence(){
  const headerHeight=header?Math.round(header.getBoundingClientRect().height):64;
  const frame=stage.clientHeight;
  sequence.style.setProperty('--sequence-header',headerHeight+'px');
  sequence.style.setProperty('--sequence-frame',frame+'px');
  sequence.style.setProperty('--sequence-hero-top',(headerHeight+Math.min(0,frame-hero.getBoundingClientRect().height))+'px');
  entryDistance=Math.min(600,frame*.75);
  track.style.height=(frame*3.6+entryDistance)+'px';
 }
 sizeSequence();
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const config={depth:2,speed:1};let frame=0,shown=0,last=0;
 const clamp=x=>Math.max(0,Math.min(1,x));const ease=x=>{x=clamp(x);return x*x*(3-2*x)};
 const at=(p,a,b)=>ease((p-a)/(b-a));
 const textStates=new Map([before,after,end].map(el=>[el,{opacity:el===before?1:0,y:0,targetOpacity:el===before?1:0,targetY:0}]));
 function text(el,visible,offset){const state=textStates.get(el);state.targetOpacity=visible;state.targetY=offset/110*12}
 function animateText(dt,instant=false){
 let busy=false;const amount=instant||reduced.matches?1:1-Math.exp(-dt/145);
 for(const [el,state] of textStates){
  state.opacity+=(state.targetOpacity-state.opacity)*amount;state.y+=(state.targetY-state.y)*amount;
  if(Math.abs(state.targetOpacity-state.opacity)<.0005)state.opacity=state.targetOpacity;else busy=true;
  if(Math.abs(state.targetY-state.y)<.01)state.y=state.targetY;else busy=true;
  el.style.opacity=state.opacity;el.style.transform=`translate3d(0,${state.y}px,0)`;
  el.setAttribute('aria-hidden',state.opacity<.05?'true':'false');
 }
 return busy;
 }
 let productShown=0,productTarget=0;
 function animateProduct(dt,instant=false){
 const target=productTarget*at(textStates.get(end).opacity,.6,.88);
 const amount=instant||reduced.matches?1:1-Math.exp(-dt/210);
 productShown+=(target-productShown)*amount;
 const busy=Math.abs(target-productShown)>.0005;if(!busy)productShown=target;
 const motion=reduced.matches?0:1;
 product.style.opacity=productShown;
 product.style.transform=`translate3d(0,${(1-productShown)*32*motion}px,0) scale(${1-(1-productShown)*.025*motion})`;
 return busy;
 }
 function paint(p){
 const mobile=root.clientWidth<=900,motion=reduced.matches?0:1;
 const reveal=at(p,.23,.40),retreat=at(p,.70,.91),introOut=at(p,.14,.26),newIn=at(p,.38,.56),newOut=at(p,.63,.77),lastIn=at(p,.81,.89);
 const zoom=1+(at(p,0,.7)*config.depth/100)*motion;
 const softness=Math.sin(reveal*Math.PI)*1.2*motion;
 cold.style.transform=`scale(${zoom})`;cold.style.opacity=(1-at(p,.56,.65))*(1-retreat);
 const tableOpacity=Math.pow(1-retreat,1.6);
 warm.style.opacity=reveal*tableOpacity;warm.style.transform=`translate3d(0,${-retreat*8*motion}px,0) scale(${zoom+retreat*.018*motion})`;
 cold.style.filter=`blur(${softness}px)`;warm.style.filter=`blur(${softness+retreat*5*motion}px)`;
 productTarget=at(p,.865,.975);
 shade.style.opacity=tableOpacity;
 q('.pm-stage').style.background=`rgb(${234-7*retreat},${241-4*retreat},245)`;
 text(before,(1-introOut)*entryOpacity,-introOut*108*motion);
 text(after,newIn*(1-newOut),((1-newIn)*110-newOut*110)*motion);
 text(end,lastIn,(1-lastIn)*105*motion);
 q('.pm-logo').style.filter=mobile||retreat>.5?'none':'brightness(0) invert(1)';
 q('.pm-scroll-hint').style.color=mobile||retreat>.5?'#173f48':'#ffffff';
 q('.pm-rule').style.background=retreat>.5?'#c6d9de':'rgba(255,255,255,.35)';q('.pm-rule span').style.background=retreat>.5?'#216370':'#fff';q('.pm-rule span').style.width=(p*100)+'%';
 root.dataset.progress=p.toFixed(3);
 }
 function update(time){const stage=q('.pm-stage'),top=parseFloat(getComputedStyle(stage).top)||0;const distance=top-track.getBoundingClientRect().top;
 const entranceTarget=clamp(distance/entryDistance);
 const entryDt=Math.min(50,time-(last||time-16));
 entranceShown=reduced.matches?entranceTarget:entranceShown+(entranceTarget-entranceShown)*(1-Math.exp(-entryDt/85));
 const entryBusy=Math.abs(entranceTarget-entranceShown)>.0001;if(!entryBusy)entranceShown=entranceTarget;
 const entrance=entranceShown;
 stage.style.opacity=at(entrance,.12,.88);
 heroCopy.style.opacity=1-at(entrance,.02,.35);
 hero.style.opacity=1-at(entrance,.7,1);
 hero.style.pointerEvents=entrance>.25?'none':'';hero.inert=entrance>.25;
 entryOpacity=at(entrance,.70,1);
 root.dataset.entrance=entrance.toFixed(3);
 const target=clamp((distance-entryDistance)/Math.max(1,track.offsetHeight-stage.clientHeight-entryDistance));const dt=Math.min(50,time-(last||time-16));last=time;shown=reduced.matches?target:shown+(target-shown)*(1-Math.exp(-dt/65));if(Math.abs(target-shown)<.0001)shown=target;paint(shown);const textBusy=animateText(dt),productBusy=animateProduct(dt);frame=shown===target&&!textBusy&&!productBusy&&!entryBusy?0:requestAnimationFrame(update)}
 function request(){if(!frame)frame=requestAnimationFrame(update)}
 let sequenceWidth=window.innerWidth;const sequenceResize=()=>{if(sequenceWidth!==window.innerWidth){sequenceWidth=window.innerWidth;sizeSequence()}request()};window.addEventListener('resize',sequenceResize);window.addEventListener('scroll',request,{passive:true});const observer=new ResizeObserver(request);observer.observe(root);reduced.addEventListener('change',request);
 root.__cleanup=()=>{window.removeEventListener('resize',sequenceResize);window.removeEventListener('scroll',request);hero.style.opacity='';heroCopy.style.opacity='';hero.style.pointerEvents='';hero.inert=false;observer.disconnect();reduced.removeEventListener('change',request);cancelAnimationFrame(frame);delete root.dataset.initialized;};
 paint(0);animateText(0,true);animateProduct(0,true);
request();return root.__cleanup;
};
document.addEventListener("presteem:story-ready",()=>window.initPresteemStoryV13());